import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { spacing } from 'ui/theme';
import { PrimaryButton, SecondaryButton } from 'ui/button';

export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.half};
`;

export const ActionButtons = ({ handleSave }: { handleSave: () => void }) => {
  return (
    <FlexEnd>
      <Link to="/integrations/webhooks">
        <SecondaryButton data-test="cancelEditWebhook">Cancel</SecondaryButton>
      </Link>
      <PrimaryButton onClick={handleSave} data-test={`saveWebhookButton`}>
        Save Webhook
      </PrimaryButton>
    </FlexEnd>
  );
};
